import React, { lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from './redux/storeConfig/store'
import { ToastContainer } from 'react-toastify'
import { ThemeContext } from './utility/context/ThemeColors'
import { FilterScreenContext } from './utility/context/FilterScreenContext'
import { Amplify } from 'aws-amplify'
import { testConfig, prodConfig } from './sp-aws-exports'
import App from './App'
import Spinner from './@core/components/spinner/Fallback-spinner'
import './@core/components/ripple-button'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'
import 'react-perfect-scrollbar/dist/css/styles.css'
import '@styles/react/libs/toastify/toastify.scss'
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'
import './assets/scss/uxrefresh.scss'
import './assets/scss/shared.scss'

if (process.env.REACT_APP_BASEURL.indexOf('//api') > 0) Amplify.configure(prodConfig)
else Amplify.configure(testConfig)

import * as serviceWorker from './serviceWorker'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error Boundary caught:', error, errorInfo, window.location.pathname)
  }

  render() {
    if (this.state.hasError) {
      const Error = lazy(() => import('@src/views/general/Error'))
      return <Error />
    }
    return this.props.children
  }
}
const AppContent = (
  <Provider store={store}>
    <Suspense fallback={<Spinner type='grow' color='primary'> </Spinner>}>
      <ThemeContext>
        <FilterScreenContext>
          <App />
          <ToastContainer newestOnTop />
        </FilterScreenContext>
      </ThemeContext>
    </Suspense>
  </Provider>
)


if (typeof window !== 'undefined') {
  const root = createRoot(document.getElementById('root'))
  root.render(process.env.NODE_ENV === 'production' ? <ErrorBoundary>{AppContent}</ErrorBoundary> : AppContent)
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register()
serviceWorker.unregister()